'use strict';

var React = require('react');

var SvgCircleMinusMajor = function SvgCircleMinusMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 20c-5.514 0-10-4.486-10-10s4.486-10 10-10 10 4.486 10 10-4.486 10-10 10zm-4-11a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8z"
  }));
};

exports.SvgCircleMinusMajor = SvgCircleMinusMajor;
